<template>
  <Drawer v-model="show"
          :mask-closable="false"
          :loading="loading"
          :title="$t('消费分布')"
          width="90%">
    <RadioGroup v-model="chartType"
                type="button"
                size="small"
                @on-change="changeType"
                class="chart-type">
      <Radio label="recharge">充值金额</Radio>
      <Radio label="order">订单支付金额</Radio>
    </RadioGroup>
    <div class="chart-pack"
         ref="consume">
    </div>
  </Drawer>
</template>
<script>
import echarts from 'echarts'
export default {
    components: {},
    data () {
        return {
            show: false,
            loading: true,
            chartType: 'recharge',
            data: []
        }
    },
    watch: {
        show (val) {
            if (!val) {
                this.inf = {}
            }
        }
    },
    methods: {
        open (data) {
            this.data = data
            this.show = true
            this.$nextTick(() => {
                this.initChart(this.data.length ? this.formatChartData(this.data) : [{ name: '', value: 0.000001, itemStyle: { color: '#e9e9e9' } }])
            })
        },
        formatChartData (val) {
            return val.map(item => {
                const children = item.orgConsumes ? this.formatChartData(item.orgConsumes) : []
                const val = this.chartType === 'recharge' ? item.rechargeAmount : item.orderAmount
                return {
                    name: item.orgName,
                    children: children,
                    itemStyle: { color: val ? null : '#e9e9e9' },
                    value: [val || 0.000001, item.rechargeAmount, item.orderAmount, item.billAmount, item.invoiceAmount]
                }
            })
        },
        changeType () {
            if (!this.data.length) {
                return
            }
            this.initChart(this.formatChartData(this.data))
        },
        initChart (data) {
            this.myChart = echarts.init(this.$refs.consume)
            const option = {
                color: ['#32c6c8', '#b5a0dd', '#5aafee', '#ff9ba1', '#8c97b1', '#f0a021', '#7dae12'],
                tooltip: {
                    formatter: (inf) => {
                        return `<div class="consume-inf">${inf.name || '账户'} <br/><span>充值金额：</span>${this.$money(inf.value[1])}<br/><span>已支付订单：</span>${this.$money(inf.value[2])}<br/><span>已出账：</span>${this.$money(inf.value[3])}<br/><span>已开票：</span>${this.$money(inf.value[4])}</div>`
                    }
                },
                series: [{
                    name: '账户',
                    type: 'treemap',
                    visibleMin: 500,
                    data: data,
                    leafDepth: 1,
                    top: 0,
                    width: '100%',
                    height: '95%',
                    levels: [
                        {
                            itemStyle: {
                                normal: {
                                    borderColor: '#fff',
                                    gapWidth: 0.5
                                }
                            }
                        },
                        {
                            colorSaturation: [0.3, 0.5]
                        }
                    ],
                    breadcrumb: {
                        show: !!this.data.length
                    }
                }]
            }

            this.myChart.setOption(option)
        }
    }
}
</script>
<style lang="less" scoped>
.chart-type {
  margin-bottom: 15px;
}
.chart-pack {
  width: 100%;
  height: calc(~"100% - 40px");
}
</style>
